const URL_API_RECAPTCHA = 'https://www.google.com/recaptcha/api.js';
const SITE_KEY = '6LcmJcUUAAAAAIEJlvQOALmm6X8FS37MLx3bY75B';

let scriptLoaded = false;
let loading = false;

/**
 * Retorna o token do reCAPTCHA v3.
 */
export default function reCAPTCHA() {
  return new Promise((resolve, reject) => {
    if (!scriptLoaded && !loading) {
      try {
        loadScriptReCAPTCHA();
      } catch (e) {
        return reject(e);
      }
    }

    const wait = setInterval(() => {
      if (scriptLoaded && window.grecaptcha) {
        clearInterval(wait);

        execute()
          .then(token => {
            const grecaptchaBadge = document.querySelector('.grecaptcha-badge');
            if (grecaptchaBadge) grecaptchaBadge.style.opacity = 1;

            resolve(token);
          })
          .catch(reject);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(wait);
      reject('Timeout ao carregar reCAPTCHA');
    }, 5000);
  });
}

export function loadScriptReCAPTCHA() {
  if (scriptLoaded || loading) return;

  loading = true;

  const script = document.createElement('script');
  script.src = `${URL_API_RECAPTCHA}?render=${SITE_KEY}`;
  script.defer = true;

  script.onload = () => {
    if (window.grecaptcha) {
      window.grecaptcha.ready(() => {
        scriptLoaded = true;
        loading = false;
      });
    }
  };

  script.onerror = () => {
    loading = false;
    console.error('Erro ao carregar script do reCAPTCHA');
  };

  document.head.appendChild(script);
}

export function setRecaptchaLoadOnFormFocus() {
  if (scriptLoaded || window.grecaptcha) return;

  const pageForms = Array.from(document.querySelectorAll('form'));
  const handleFocus = () => {
    try {
      loadScriptReCAPTCHA();
    } catch {
      console.log('Erro ao carregar script de recaptcha');
    }
  };

  pageForms.forEach(form =>
    form.addEventListener('focusin', handleFocus, { once: true })
  );
}

function execute() {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      return reject('grecaptcha ainda não está disponível');
    }

    window.grecaptcha
      .execute(SITE_KEY, { action: 'homepage' })
      .then(token =>
        token
          ? resolve(token)
          : reject('Não foi possível pegar o token da API google reCAPTCHA v3')
      )
      .catch(reject);
  });
}
